import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types";

@Component({})
export class EntityListView<T = unknown> extends Vue {
  @Prop({
    default: () => [],
  })
  public readonly items!: T[];

  @Prop({
    default: false,
  })
  public readonly selectable!: boolean;

  @Prop({
    default: () => [],
  })
  public readonly visibleHeaders!: string[];

  public readonly headers!: DataTableHeader[];

  public readonly selectableKey!: string;

  @Emit()
  public onSelect(_selectedItem: { item: T; value: boolean }): void {}
}
